import { render, staticRenderFns } from "./MessageDropdown.vue?vue&type=template&id=7b41499d&"
import script from "./MessageDropdown.vue?vue&type=script&lang=js&"
export * from "./MessageDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports